var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1548_5086)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0029 22.501C9.21816 22.501 6.54744 21.3947 4.57831 19.4256C2.60918 17.4565 1.50293 14.7858 1.50293 12.001C1.50293 9.2162 2.60918 6.54549 4.57831 4.57635C6.54744 2.60722 9.21816 1.50098 12.0029 1.50098C14.7877 1.50098 17.4584 2.60722 19.4276 4.57635C21.3967 6.54549 22.5029 9.2162 22.5029 12.001C22.5029 14.7858 21.3967 17.4565 19.4276 19.4256C17.4584 21.3947 14.7877 22.501 12.0029 22.501ZM12.0029 24.001C15.1855 24.001 18.2378 22.7367 20.4882 20.4863C22.7386 18.2358 24.0029 15.1836 24.0029 12.001C24.0029 8.81838 22.7386 5.76613 20.4882 3.5157C18.2378 1.26526 15.1855 0.000976563 12.0029 0.000976562C8.82033 0.000976563 5.76808 1.26526 3.51765 3.5157C1.26721 5.76613 0.00292969 8.81838 0.00292969 12.001C0.00292969 15.1836 1.26721 18.2358 3.51765 20.4863C5.76808 22.7367 8.82033 24.001 12.0029 24.001Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3979 9.88298L9.96293 10.3135L9.83993 10.8835L10.5149 11.008C10.9559 11.113 11.0429 11.272 10.9469 11.7115L9.83993 16.9135C9.54893 18.259 9.99743 18.892 11.0519 18.892C11.8694 18.892 12.8189 18.514 13.2494 17.995L13.3814 17.371C13.0814 17.635 12.6434 17.74 12.3524 17.74C11.9399 17.74 11.7899 17.4505 11.8964 16.9405L13.3979 9.88298ZM13.5029 6.75098C13.5029 7.1488 13.3449 7.53033 13.0636 7.81164C12.7823 8.09294 12.4008 8.25098 12.0029 8.25098C11.6051 8.25098 11.2236 8.09294 10.9423 7.81164C10.661 7.53033 10.5029 7.1488 10.5029 6.75098C10.5029 6.35315 10.661 5.97162 10.9423 5.69032C11.2236 5.40901 11.6051 5.25098 12.0029 5.25098C12.4008 5.25098 12.7823 5.40901 13.0636 5.69032C13.3449 5.97162 13.5029 6.35315 13.5029 6.75098Z",
    fill: "#6C757D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1548_5086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/Info-circle.0103dfee73d5a918690c9604d657725a.svg";
export { ForwardRef as ReactComponent };